import { PaginatedResult, PaginationParams, serializePagination } from '../../pagination';
import { API_HR_PATH, getClient } from '../api';
import { HRCalendarEvent } from '../dtos';
import { serializeParams } from '../utils/serializer';

export interface GetHRCalendarEventsFilters {
  jobApplicationId?: string,
  applicantId?: string,
  isActive?: boolean,
}

export const createHRCalendarEvent = async <T extends HRCalendarEvent>(calendarEvent: T): Promise<T> => {
  const client = await getClient();
  const { data } = await client.post<T>(`${API_HR_PATH}/calendar-events`, calendarEvent);
  return data;
};

export const updateHRCalendarEvent = async <T extends HRCalendarEvent>(id: NonNullable<HRCalendarEvent['id']>, calendarEvent: T): Promise<T> => {
  const client = await getClient();
  const { data } = await client.put<T>(`${API_HR_PATH}/calendar-events/${id}`, calendarEvent);
  return data;
};

export const deleteHRCalendarEvent = async (id: NonNullable<HRCalendarEvent['id']>): Promise<void> => {
  const client = await getClient();
  const { data } = await client.delete<void>(`${API_HR_PATH}/calendar-events/${id}`);
  return data;
};

export const getHRCalendarEvents = async (
  filters: GetHRCalendarEventsFilters = {},
  pagination: PaginationParams = {},
): Promise<PaginatedResult<HRCalendarEvent>> => {
  const client = await getClient();
  const { data } = await client.get<PaginatedResult<HRCalendarEvent>>(`${API_HR_PATH}/calendar-events`,
    {
      params: {
        ...serializeParams(filters),
        ...serializePagination(pagination),
      },
    });

  return data;
};

export async function getHRCalendarEvent(id: NonNullable<HRCalendarEvent['id']>): Promise<HRCalendarEvent> {
  const client = await getClient();
  const { data } = await client.get<HRCalendarEvent>(`${API_HR_PATH}/calendar-events/${id}`);

  return data;
}
